import React from "react";
import { FaInstagram } from "react-icons/fa";
import fetchJsonp from 'fetch-jsonp';
import qs from 'query-string';
import { Redirect } from 'react-router-dom';
import logoS from "../../../assets/images/s-white-on-black-logo.png";


import Step from "../Step";
import StateMachine from "src/components/utils/StateMachine";
import WithUserForm from "../../Register/WithUserForm";

import styles from "../styles.module.css";
import DotWaveLoader from "../../../assets/DotWaveLoader/DotWaveLoader";

const redirectUri = `${window.location.origin}/apply/instagram`.replace("http://", "https://");

class InstagramConnect extends React.Component {
  state = {
    showVerifyModal: false,
    hasMediaAccess: false,
    accessToken: null,
  };

  componentDidMount() {
    this.getAuthenticateToken();
    this.getAccessToken();
  }

  showVerifyModal = () => {
    this.setState({
      showVerifyModal: true,
    });
    setTimeout(() => {
      this.waitFor((_) => this.state.hasMediaAccess).then((_) =>
        this.setState({ showVerifyModal: false })
      );
    }, 2000);
  };

  waitFor(conditionFunction) {
    const poll = (resolve) => {
      if (conditionFunction()) resolve();
      else setTimeout((_) => poll(resolve), 300);
    };
    return new Promise(poll);
  }

  getAccessToken = async () => {
    const hashString = window.location.search.substr(1, window.location.search.indexOf("&state") - 1);
    if (hashString.startsWith('code')) {
      this.showVerifyModal();
      const accessCode = hashString.substr(5);
      try {
        const response = await this.props.exchangeToken({
          variables: {
            code: accessCode,
            redirectUri
          },
        });
        let userAccessToken = response.data.exchangeToken;
        // Refetch current user to ensure instagramToken is available before proceeding to photo selection
        await this.props.userQuery.refetchCurrentUser();
        this.setState({ accessToken: userAccessToken });
        this.checkMediaAccess();
      }
      catch (error) {
        console.log(error)
      }
    }
  };

  checkMediaAccess = async () => {
    const queryString = qs.stringify({
      access_token: this.state.accessToken,
    });
    const body = await fetchJsonp(
      'https://graph.instagram.com/v21.0/me/media/?' + queryString
    ).then((res) => res.json())
    .catch (error => console.log(error));

    if (!body.hasOwnProperty('error')) {
      this.setState({ hasMediaAccess: true });
    }
  };

  getAuthenticateToken = () => {
    const hashString = window.location.search.substr(window.location.search.indexOf("state="));
    const authToken = hashString.substr(6);

    if (!window.localStorage.getItem("token")) {
      window.localStorage.setItem("token", authToken);
    }
  }

  render() {
    const hashString = window.location.search.substr(1);

    if ( !this.state.showVerifyModal && this.state.hasMediaAccess ) {
      return <Redirect to='/apply/photos' />;
    }

    return (
      <StateMachine.Consumer>
        {() => {
          const startInstagramOAuth = () => {
            const query = qs.stringify({
              client_id: process.env.REACT_APP_SCHMODEL_INSTAGRAM_APP_ID,
              redirect_uri: redirectUri,
              scope: "instagram_business_basic",
              response_type: "code",
              state: window.localStorage.getItem("token")
            });
            window.location.href = `https://www.instagram.com/oauth/authorize?${query}`;
          };
          const footer = (<>
            {!this.state.showVerifyModal &&
              <div
                  style={{
                    width: '90vw',
                    maxWidth: '400px',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    paddingBottom: '10px'
                  }}
              >
                <div style={{ width: '100%', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  {/* Center cta button in available space between text and footer*/}
                  <button
                      className={`${styles.wrap_instagram}`}
                      onClick={startInstagramOAuth}
                  >
                    <FaInstagram size={25} />
                    CONNECT TO INSTAGRAM
                  </button>
                </div>
                <p
                    className={` ${styles.default_text_size}`}
                    style={{
                      color: '#B08D57',
                      lineHeight: 0.9
                    }}
                >
                  Having trouble? <a href="https://wa.me/447588663357" style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Contact us</a>.
                </p>
              </div>
            }
          </>);
          return (<Step footer={footer} centerContent={this.state.showVerifyModal}>
            <div className='w-full flex flex-col items-center'>
              {hashString?.startsWith("error") && (
                  <div
                      style={{
                        color: "#e04344",
                        fontSize: 'clamp(1px, 3.5vw, 15px)',
                        width: '100%',
                        textAlign: "center",
                        marginBottom: '1vh'
                      }}
                  >
                    <strong style={{ display: "inline" }}>Oops! </strong>
                    Your IG connection failed. Make sure you<br />
                    click ‘Allow’ when prompted. Please try again.
                  </div>
              )}
              <div className={`${styles.content}`}>
                To verify your identity and allow you access<br />
                to Schmodel services, IG will connect your<br />
                account for ID validation and media access <br />
                (allowing you to upload profile images).
                <br />
                <br />
                This allows us to confirm your Instagram<br />
                identity and allow you access to all services.
                <br />
                <br />
                No private information is shared with us <br />
                that isn't already publicly available. <br />
                Visit Instagram's T&C's for more details.
                <br />
                <br />
                Instagram does not allow private accounts<br />
                to connect - you must have (or change to) a<br />
                professional account (business or creator).
                <br />
                <br />
                You will be prompted for media access in <br />
                order to upload 6 Instagram posts of your <br />
                choice that best represent you and your work.
              </div>
              {this.state.showVerifyModal && (
                <div className={styles.verifyingOverlay}>
                  <div className={styles.verifyingContent}>
                    <h2 className={styles.verifyingTitle}>VERIFYING<br />PROFILE</h2>
                    <div className={styles.loaderContainer}>
                      <FaInstagram size={40} className={styles.loaderIcon} />
                      <DotWaveLoader />
                      <div className={styles.loaderS}>
                        <img src={logoS} className='h-full' alt="logo"/>
                      </div>
                    </div>
                    <p className={styles.verifyingText}>
                      Please wait while Instagram<br />confirms your profile
                    </p>
                  </div>
                </div>
              )}
            </div>
          </Step>
        )}}
      </StateMachine.Consumer>
    );
  }
}

class AccessInstagram extends React.Component {
  render() {
    return <WithUserForm
      render={(props) => <InstagramConnect {...props} />}
    />;
  }
}

export default AccessInstagram;
